import { IObject } from "@quest/adapter-interface";
import { Model } from "@quest/platform-murka/dist";

export class GameParserModel extends Model {
  private stackSymbolsOffsets: number[][][] = []
  private freeSpinSymbolNormalosOffsets: number[][] = [];
  private freeSpinSymbolsOffsets: number[][] = []
  private awardJackpotsFG: IObject;
  private isAwardJackpotsFG: boolean = false;
  private isAwardGrandJackpotsFG: boolean = false;
  private linesWinUniquePositionsGame: number[][] = [];
  private isMagicPotionBG: boolean = false;
  private isMagicPotionFG: boolean = false;
  private isJackpotWonBG: boolean = false;
  private potionJackpotPositionsBG: IObject[];
  private potionPointPositionsBG: IObject[];
  private potionPointPositionsFG: IObject[];
  private potionJackpotPositionsFG: IObject[];
  private numberOfPotsBG: number = 0;
  private prizePotCredit: number = 0;
  private prizePotCreditFG: number = 0;
  private jackpotWonBG: IObject;
  private potOffsets: number[][] = [];
  private potOffsetsFG: number[][] = [];
  private grandJackpotWonBG: number = 0;
  private majorJackpotWonBG: number = 0;
  private minorJackpotWonBG: number = 0;
  private miniJackpotWonBG: number = 0;
  private isFSPotPresent: Boolean = false;
  private allCapsuleData: IObject = {};
  private currentCapsuleFilled: IObject = {};
  private grandJackpotPrizeFG: number;
  private majorJackpotPrizeFG: number;
  private minorJackpotPrizeFG: number;
  private miniJackpotPrizeFG: number;
  private jackpotMultipliersFg: IObject = {};
  private currentTotalLineWin: number;
  private totalJackpotWinFG: number=0;
  private allReelSet: { [key: string]: number[][] }
  private revealSymNum: number = 10;
  // Stack Feature
  private isStackSym: boolean = false;
  private commonOffsetsOfStackAndWin: number[][][] = [];
  private stackSymOffsets: number[][] = [];
  private isStackSymFG: boolean = false;
  private stackSymOffsetsFG: number[][] = [];
  private fSCurrentSpinWin: number = 0;

  private retriggerWithExtraSpin: boolean = false;

  private grandJackpotWin: number = 0;

  private jackpotMultipliers: IObject = {};
  private winLineAmount: number = 0;
  private totalBaseGameWinAmt: number = 0;

  /**
   * Model to set stack symbol offsets
   * @param value
   */
  public setStackSymbolOffsets(value: number[][][]): void {
    this.stackSymbolsOffsets = value;
  }

  /**
   * Model to get stack symbol offsets
   * @returns
   */
  public getStackSymbolOffsets(): number[][][] {
    return this.stackSymbolsOffsets;
  }

  /**
     * Model to get free spin symbol offsets of scatter normal / 110
     * @returns 
     */
  public getFreeSymNormalOffsets(): number[][] {
    return this.freeSpinSymbolNormalosOffsets;
  }

  /**
   * Model to get free spin symbol offsets of scatter normal / 120
   * @returns 
   */
  public setFreeSymNormalOffsets(value: number[][]): void {
    this.freeSpinSymbolNormalosOffsets = value;
  }

  /**
  * Model to set true if free spin triggered
  * @params value
  */
  public setIsFreeSpintriggered(value: boolean) {
    this.freeSpinTrigger = value;
  }

  /**
   * Model to get free spin symbol offsets
   * @returns 
   */
  public getFSSymbolOffsets(): number[][] {
    return this.freeSpinSymbolsOffsets;
  }

  /**
   * Model to set free spin symbol offsets
   * @returns 
   */
  public setFSSymboloffsets(value: number[][]): void {
    this.freeSpinSymbolsOffsets = value;
  }

  /**
   * Model to get true if jackpot awards during FG
   * @returns
   */
  public getAwardJackpotsFG(): IObject {
    return this.awardJackpotsFG;

  }

  /**
   * Model to set true if jackpot awards during FG
   * @params value
   */
  public setAwardJackpotsFG(value: IObject): void {
    this.awardJackpotsFG = value;
  }

  /**
   * Model to get true if jackpot award
   * @returns
   */
  public getIsJackpotAward(): Boolean {
    return this.isAwardJackpotsFG;

  }

  //set true if JP is award during FG
  public setIsJackpotAward(value: boolean) {
    this.isAwardJackpotsFG = value;
  }

  // Stack Feature model

  //set true if stack symbol present
  public setStackSymPresent(value: boolean): boolean {
    return this.isStackSym = value;
  }

  //get if stack symbol present
  public getStackSymPresent(): boolean {
    return this.isStackSym;
  }

  //set stack symbol offsets
  public setStackSymOffsets(value: number[][]): void {
    this.stackSymOffsets = value;
  }

  //get stack symbol offsets
  public getStackSymOffsets(): number[][] {
    return this.stackSymOffsets;
  }

  //set true if stack symbol present
  public setStackSymPresentFG(value: boolean): boolean {
    return this.isStackSymFG = value;
  }

  //get if stack symbol present
  public getStackSymPresentFG(): boolean {
    return this.isStackSymFG;
  }

  //set stack symbol offsets
  public setStackSymOffsetsFG(value: number[][]): void {
    this.stackSymOffsetsFG = value;
  }

  //get stack symbol offsets
  public getStackSymOffsetsFG(): number[][] {
    return this.stackSymOffsetsFG;
  }


  //set stack symbol offsets
  public setCommonOffsetsOfStackAndWin(value: number[][][]): void {
    this.commonOffsetsOfStackAndWin = value;
  }

  //get stack symbol offsets
  public getCommonOffsetsOfStackAndWin(): number[][][] {
    return this.commonOffsetsOfStackAndWin;
  }

  /**
   * setLinesWinUniquePositions method overrided to initialize the linesWinUniquePositions with intial value.
   * @param value 
   */
  setLinesWinUniquePositions(value: number[][]): void {
    this.linesWinUniquePositionsGame = value;
  }

  /**
 * getLinesWinAllUniquePositions method overrided to initialize the linesWinUniquePositions with intial value.
 * @param value 
 */
  getLinesWinAllUniquePositions(): number[][] {
    return this.linesWinUniquePositionsGame;
  }

  /**
   * Model to get potion with jackpot positions during BG
   * @params value
   */
  public getPotionJackpotPositionsBG(): IObject[] {
    return this.potionJackpotPositionsBG;

  }

  /**
   * Model to set potion with jackpot positions during BG
   * @params value
   */
  public setPotionJackpotPositionsBG(value: IObject[]): void {
    this.potionJackpotPositionsBG = value;

  }

  /**
   * Model to get potion with jackpot positions during FG
   * @returns
   */
  public getPotionJackpotPositionsFG(): IObject[] {
    return this.potionJackpotPositionsFG;

  }

  /**
   * Model to set potion with jackpot positions during FG
   * @params value
   */
  public setPotionJackpotPositionsFG(value: IObject[]): void {
    this.potionJackpotPositionsFG = value;

  }

  /**
   * Model to get potion point positions during BG
   * @returns
   */
  public getPotionPointPositionsBG(): IObject[] {
    return this.potionPointPositionsBG;

  }

  /**
   * Model to set potion point positions during BG
   * @params value
   */
  public setPotionPointPositionsBG(value: IObject[]): void {
    this.potionPointPositionsBG = value;

  }

  /**
   * Model to get potion point posistions during FG
   * @returns
   */
  public getPotionPointPositionsFG(): IObject[] {
    return this.potionPointPositionsFG;

  }

  /**
   * Model to set potion point posistions during FG
   * @params value
   */
  public setPotionPointPositionsFG(value: IObject[]): void {
    this.potionPointPositionsFG = value;

  }

  /**
   * Model to get true if magic potion triggers during BG
   * @returns
   */
  public getIsMagicPotionBG(): boolean {
    return this.isMagicPotionBG;

  }

  /**
   * Model to set true if magic potion triggers during BG
   * @params value
   */
  public setIsMagicPotionBG(value: boolean): void {
    this.isMagicPotionBG = value;

  }

  /**
   * Model to get true if magic potion triggers during FG
   * @returns
   */
  public getIsMagicPotionFG(): boolean {
    return this.isMagicPotionFG;

  }

  /**
   * Model to set true if magic potion triggers during FG
   * @params value
   */
  public setIsMagicPotionFG(value: boolean): void {
    this.isMagicPotionFG = value;

  }

  /**
   * Model to get number of pots during BG
   * @returns
   */
  public getNumberOfPotsBG(): number {
    return this.numberOfPotsBG;
  }

  /**
   * Model to set number of pots during BG
   * @params value
   */
  public setNumberOfPotsBG(value: number): void {
    this.numberOfPotsBG = value;
  }

  /**
   * Model to get prize pot during FG
   * @returns
   */
  public getPrizePotCredit(): number {
    return this.prizePotCredit;
  }

  /**
   * Model to set prize pot
   * @params value
   */
  public setPrizePotCredit(value: number) {
    this.prizePotCredit = value;
  }

  /**
   * Model to get prize pot during FG
   * @returns
   */
  public getPrizePotCreditFG(): number {
    return this.prizePotCreditFG;
  }

  /**
   * Model to set prize pot during FG
   * @params value
   */
  public setPrizePotCreditFG(value: number) {
    this.prizePotCreditFG = value;
  }

  /**
   * Model to get boolean for jackpots won during BG
   * @params value
   */
  public getIsJackpotWonBG(): boolean {
    return this.isJackpotWonBG;
  }

  /**
   * Model to set true if jackpots won during BG
   * @params value
   */
  public setIsJackpotWonBG(value: boolean): void {
    this.isJackpotWonBG = value;

  }

  /**
   * Model to get jackpots won during BG
   * @returns
   */
  public getJackpotWonBG(): IObject {
    return this.jackpotWonBG;

  }

  /**
   * Model to set jackpots won during BG
   * @params value
   */
  public setJackpotWonBG(value: IObject): void {
    this.jackpotWonBG = value;
  }

  /**
   * Model to get motion pot offsets
   * @returns
   */
  public getMotionPotOffsets(): number[][] {
    return this.potOffsets;
  }

  /**
   * Model to set motion pot offsets
   * @params value
   */
  public setMotionPotOffsets(value: number[][]): void {
    this.potOffsets = value;
  }

  /**
   * Model to get motion pot offsets during FG
   * @returns
   */
  public getMotionPotOffsetsFG(): number[][] {
    return this.potOffsetsFG;
  }

  /**
   * Model to set motion pot offsets during FG
   * @params value
   */
  public setMotionPotOffsetsFG(value: number[][]): void {
    this.potOffsetsFG = value;
  }

  /**
   * Model to get grand jackpot won during BG
   * @returns
   */
  public getGrandJackpotWonBG(): number {
    return this.grandJackpotWonBG;

  }

  /**
   * Model to set grand jackpot won during BG
   * @params value
   */
  public setGrandJackpotWonBG(value: number): void {
    this.grandJackpotWonBG = value;
  }

  /**
   * Model to get major jackpot won during BG
   * @returns
   */
  public getMajorJackpotWonBG(): number {
    return this.majorJackpotWonBG;

  }

  /**
   * Model to set major jackpot won during BG
   * @params value
   */
  public setMajorJackpotWonBG(value: number): void {
    this.majorJackpotWonBG = value;
  }

  /**
   * Model to get minor jackpot won during BG
   * @returns
   */
  public getMinorJackpotWonBG(): number {
    return this.minorJackpotWonBG;

  }

  /**
   * Model to set minor jackpot won during BG
   * @params value
   */
  public setMinorJackpotWonBG(value: number): void {
    this.minorJackpotWonBG = value;
  }

  /**
   * Model to get mini jackpot won during BG
   * @returns
   */
  public getMiniJackpotWonBG(): number {
    return this.miniJackpotWonBG;

  }

  /**
   * Model to set mini jackpot won during BG
   * @params value
   */
  public setMiniJackpotWonBG(value: number): void {
    this.miniJackpotWonBG = value;
  }

  /**
   * Model to get if scatter pot present
   * @returns
   */
  public getIsFSPotPresentBG(): Boolean {
    return this.isFSPotPresent;
  }

  /**
     * Model to set true if scatter pot present
     * @params value
     */
  public setIsFSPotPresentBG(value: Boolean): void {
    this.isFSPotPresent = value;
  }


  //  Model for setting retrigger with Extra spin
  public setRetriggerWithExtraSpin(value: boolean): void {
    this.retriggerWithExtraSpin = value;
  }

  // Model for getting retrigger with Extra spin
  public getRetriggerWithExtraSpin(): boolean {
    return this.retriggerWithExtraSpin;
  }

  /**
   * Model to get grand jackpot win FG
   * @returns
   */
  public getGrandJackpotWinFG(): number {
    return this.grandJackpotWin;

  }

  /**
   * Model to set grand jackpot win FG
   * @params value
   */
  public setGrandJackpotWinFG(value: number): void {
    this.grandJackpotWin = value;
  }

  /**
   * Method to set jackpot multipliers values
   * @param value 
   */
  public setJackpotMultipliers(value: IObject): void {
    this.jackpotMultipliers = value;
  }

  /**
   * Method to get jackpot multipliers values
   * @returns 
   */
  public getJackpotMultipliers(): IObject {
    return this.jackpotMultipliers;
  }

  //Capsule count from server
  public getTotalCapsuleCount(): IObject {
    return this.allCapsuleData;
  }

  /**
   * Model to set total capsule count
   * @params value
   */
  public setTotalCapsuleCount(value: IObject): void {
    this.allCapsuleData = value;
  }

  //Current capsule filled in top bar
  public getCurrentCapsuleFilled(): IObject {
    return this.currentCapsuleFilled;
  }

  /**
   * Model to set current capsule filled
   * @params value
   */
  public setCurrentCapsuleFilled(value: IObject): void {
    this.currentCapsuleFilled = value;
  }

  /**
   * Model to check if get grand jackpot awards
   * @returns
   */
  public getIsGrandJackpotAward(): Boolean {
    return this.isAwardGrandJackpotsFG;
  }

  //set true if JP is award during FG
  public setIsGrandJackpotAward(value: boolean) {
    this.isAwardGrandJackpotsFG = value;
  }

  /**
   * Model to get grand jackpot prize during FG
   * @returns
   */
  public getGrandJackpotPrizeFG(): number {
    return this.grandJackpotPrizeFG;
  }

  //set true if JP is award during FG
  public setGrandJackpotPrizeFG(value: number) {
    this.grandJackpotPrizeFG = value;
  }

  /**
   * Model to get major jackpot prize during FG
   * @returns
   */
  public getMajorJackpotPrizeFG(): number {
    return this.majorJackpotPrizeFG;
  }

  //set true if JP is award during FG
  public setMajorJackpotPrizeFG(value: number) {
    this.majorJackpotPrizeFG = value;
  }

  /**
   * Model to get minor jackpot prize during FG
   * @returns
   */
  public getMinorJackpotPrizeFG(): number {
    return this.minorJackpotPrizeFG;
  }

  //set true if JP is award during FG
  public setMinorJackpotPrizeFG(value: number) {
    this.minorJackpotPrizeFG = value;
  }

  /**
   * Model to get mini jackpot prize during FG
   * @returns
   */
  public getMiniJackpotPrizeFG(): number {
    return this.miniJackpotPrizeFG;
  }

  //set true if JP is award during FG
  public setMiniJackpotPrizeFG(value: number) {
    this.miniJackpotPrizeFG = value;
  }

  /**
   * Model to get jackpot multipliers during FG
   * @returns
   */
  public getjackpotMultipliersFG(): IObject {
    return this.jackpotMultipliersFg;
  }

  /**
   * Model to set jackpot multipliers during FG
   * @params value
   */
  public setjackpotMultipliersFG(value: IObject): void {
    this.jackpotMultipliersFg = value;
  }

  /**
   * Model to get total line win
   * @returns
   */
  public getTotalLineWin(): number {
    return this.currentTotalLineWin;
  }

  /**
   * Model to set total total line win
   * @params value
   */
  public setTotalLineWin(value: number): void {
    this.currentTotalLineWin = value;
  }

  /**
  * Model to get total jackpot win during FG
  * @returns
  */
  public getTotalJackpotWinFG(): number {
    return this.totalJackpotWinFG;
  }

  /**
   * Model to set total jackpot win during FG
   * @params value
   */
  public setTotalJackpotWinFG(value: number): void {
    this.totalJackpotWinFG = value;
  }

  //to store all reel sets
  public setAllReelSet(value: { [key: string]: number[][] }): void {
    this.allReelSet = value;
  }
  public getAllReelSet(reelSet: string): number[][] {
    return this.allReelSet[reelSet];
  }

  //to store revealSymbol number
  public setRevealSymNum(value: number): void {
    this.revealSymNum = value;
  }
  public getRevealSymNum(): number {
    return this.revealSymNum;
  }

  /**to set and get WinlineAmount */
  public setWinLineAmount(value: number): void {
    this.winLineAmount = value;
  }

  public getWinLineAmount(): number {
    return this.winLineAmount;
  }

  //get freespin win till previous spin
  public getFSCurrentSpinWin(): number {
    return this.fSCurrentSpinWin
  }

  public getTotalBaseGameWinAmt():number{
    return this.totalBaseGameWinAmt;
    // return this.getBaseGameWinAmt() + this.getPrizePotCredit() + this.getGrandJackpotWonBG() + this.getMiniJackpotWonBG() + this.getMinorJackpotWonBG() + this.getMajorJackpotWonBG();
  }
  //get freespin win till previous spin
  public setFSCurrentSpinWin(value: number): void {
    this.fSCurrentSpinWin = value
  }

  //Method returns a reset broken saved data in freegame
  public getUserGameCloseData() {
    let UserGameData = {
      name: "brokenData",
      data: {
        data: {
          AfterBrokenSpinsRemaining: 0,
          CurrentCount: 0,
          brokenInFg: false,
          currentTotal: 0
        }
      }
    };
    return UserGameData;
  }
  public setBalance(value: number): void {
    super.setBalance(Number(value));
  }
  public setFreeBalance(value: number): void {
    super.setFreeBalance(Number(value));
  }
  public setCurrentWin(value: number): void {
    super.setCurrentWin(Number(value));
  }

  public setTotalWin(value: number): void {
    super.setTotalWin(Number(value));
  }

  public setGameWinAmt(value: number): void {
    super.setGameWinAmt(Number(value));
  }

  public setTotalBaseGameWinAmt(value: number): void {
    this.totalBaseGameWinAmt = value;
  }
  public setCurrentSpinTotalWinAmt(value: number): void {
    super.setCurrentSpinTotalWinAmt(Number(value));
  }
}
